
import React from 'react';

interface NauticLogoProps {
  className?: string;
  withText?: boolean;
  textSize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

const NauticLogo: React.FC<NauticLogoProps> = ({ 
  className = '', 
  withText = false,
  textSize = 'md'
}) => {
  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl',
    '2xl': 'text-5xl md:text-6xl'
  };

  const iconSizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-12 h-12',
    '2xl': 'w-[150px] h-[150px] -m-8'
  };

  if (withText) {
    return (
      <div className={`flex items-center gap-0 ${className}`}>
        <img 
          src="/lovable-uploads/NAUTICOACH_1.png" 
          alt="Anchor Logo"
          className={`${iconSizeClasses[textSize]} object-contain`}
        />
        <span className={`font-bold ${textSizeClasses[textSize]}`}>
          NAUTICOACH
        </span>
      </div>
    );
  }

  return (
    <img 
      src="/lovable-uploads/NAUTICOACH_1.png" 
      alt="Anchor Logo"
      className={`w-8 h-8 ${className}`}
    />
  );
};

export default NauticLogo;
